// extracted by mini-css-extract-plugin
export default {"clientSection":"OurClient_clientSection__vbYI6","title":"OurClient_title__E1awX","grid":"OurClient_grid__nr0PS","card":"OurClient_card__G+9Eq"};